import CameraControlsImpl from 'camera-controls';
import { create } from 'zustand';
import { ThreeRootState } from '@modules/three/common/BaseThreeScene';

interface ThreeStoreState {
  cameraControls: CameraControlsImpl | null;
  setCameraControls: (camera: CameraControlsImpl) => void;

  rootState: ThreeRootState;
  setRootState: (rootState: ThreeRootState) => void;

  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const threeStore = create<ThreeStoreState>((set, _get) => ({
  cameraControls: null,
  setCameraControls: (camera) => set({ cameraControls: camera }),

  rootState: null!,
  setRootState: (rootState) => set({ rootState }),

  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
}));
